interface OrgRole {
  organization_id: string;
  user_role: string;
  is_primary: boolean;
}

interface SourceSystem {
  source_system: string;
  source_id: string;
}

interface RosterUser {
  userId: string;
  type: string;
  dob: string;
  username: string;
  grade?: string;
  given_name: string;
  family_name: string;
  org_roles: OrgRole[];
  source_system_identifiers: SourceSystem[];
}

export async function fetchRosterUser(userId: string) {
  const response = await fetch(`/api/roster/v2/users/${userId}`);
  return (await response.json()) as RosterUser;
}
